import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useOrderIsConfirmable, useOrderIsSyncing } from '@/hooks/api/order';
import DotLoader from '@/common/dot-loader';

const { classNames } = Mobi2Go.helpers;
const { Order, UI } = Mobi2Go;

const onCheckoutClickHandler = onCheckoutClick => {
    // CB 5/2/21 - Dion said hardcoding main_page was fine here
    UI.trigger('progressForward', 'main_page');
};

const CheckoutButton = () => {
    const [t] = useTranslation('order.progress');
    const is_confirmable = useOrderIsConfirmable();
    const is_syncing = useOrderIsSyncing();
    const [is_waiting_on_sync, setIsWaitingOnSync] = useState(false);

    const onCheckoutClick = () => {
        if (is_waiting_on_sync) {
            return;
        }
        if (is_syncing) {
            setIsWaitingOnSync(true);
            Order.once('syncSuccess', () => {
                setIsWaitingOnSync(false);
                onCheckoutClickHandler(onCheckoutClick);
            });
            return;
        }
        if (
            Order.getLocation().isCurbsidePickupEnabled() &&
            Order.isCurbsidePickupOrder() &&
            !Order.areCurbsideDetailsComplete()
        ) {
            UI.trigger('showCurbsidePickupModal');
            return;
        }
        onCheckoutClickHandler(onCheckoutClick);
    };

    const is_disabled = !is_confirmable;

    return (
        <button
            data-checkout
            className={classNames(
                'm2g-order-payment-checkout-button',
                'm2g-button',
                'm2g-button--primary',
                'm2g-button--fat',
                'm2g-form-element--full-width',
                {
                    'm2g-button--disabled': is_disabled,
                }
            )}
            style={{ marginTop: '24px' }}
            type="button"
            onClick={onCheckoutClick}
        >
            {is_waiting_on_sync ? (
                <DotLoader dotCharacter="•" />
            ) : (
                t('checkout_button_label')
            )}
        </button>
    );
};

export default CheckoutButton;
